
import React from 'react'
import styled from 'styled-components'
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineContent from '@mui/lab/TimelineContent';
import { education } from '../../data/constants';
import EducationCard from '../Cards/EducationCard';
import { RoughUnderline } from '../common/Rough';
import { ChalkDoodles } from '../common/Doodles';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 0px 16px 60px 16px;
`;

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1000px;
    padding: 40px 0px 0px 0px;
    gap: 12px;
    @media (max-width: 960px) {
        flex-direction: column;
    }
`;

const Title = styled.div`
font-family: 'Caveat', cursive;
font-size: 52px;
text-align: center;
font-weight: 700;
margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
      margin-top: 12px;
      font-size: 40px;
  }
`;

const TitleUnderline = styled.div`
  width: 190px;
  margin: -8px auto 0 auto;
`;


const TimelineSection = styled.div`
    width: 100%;
    max-width: 1000px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    @media (max-width: 660px) {
        align-items: end;
    }

    .MuiTimelineItem-root::before {
      display: none;
    }
`;



const index = () => {
    return (
        <Container id="education">
            <ChalkDoodles seedBase={29} count={6} />
            <Wrapper>
                <Title>Education</Title>
                <TitleUnderline>
                    <RoughUnderline height={16} strokeWidth={3.5} />
                </TitleUnderline>
                <TimelineSection>
                    <Timeline>
                        {education.map((education) => (
                            <TimelineItem key={education.id}>
                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                    <EducationCard education={education}/>
                                </TimelineContent>
                            </TimelineItem>
                        ))}
                    </Timeline>

                </TimelineSection>
            </Wrapper>
        </Container>
    )
}

export default index
